// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nheader h3[data-v-08aa9929] {\n  font-size: 20px;\n  color:#ffffff;\n  width:300px;\n  height:40px;\n  text-align:center;\n  line-height:40px;\n  background-color:#00A2FF;\n  border-radius:20px;\n  margin: 0 auto;\n}\nheader p[data-v-08aa9929] {\n  margin-top:16px;\n  color:#333333;\n  font-size:16px;\n  line-height:33px;\n  letter-spacing:1px;\n  text-indent: 2em;\n}\n\n\n", ""]);
// Exports
module.exports = exports;
